import { z } from 'zod';

export const CandleAlignmentSchema = z.enum(['balance','chaos','order']);

export type CandleAlignmentType = `${z.infer<typeof CandleAlignmentSchema>}`

export default CandleAlignmentSchema;
